import {
  type IReference,
  ReferenceType,
} from '../../../../expressions/references/IReference.ts';
import {
  type IReferencePath,
  ReferencePathDirection,
} from '../../../../expressions/references/IReferencePath.ts';
import {
  type IButtonActionExecAsyncService,
  isButtonActionExecAsyncService,
} from './actions/IButtonAction.ts';
import { getActionDataObjectName } from './getActionDataObjectName.ts';
import { type IButtonWidget } from './IButtonWidget.ts';

export function getButtonWidgetSiblingReferences(
  path: IReferencePath,
  widget: IButtonWidget,
): IReference[] {
  const serviceActions = widget.actions?.map((action, index) => ({
    action,
    index,
  }));

  const result: IReference[] = [];

  serviceActions?.forEach(action => {
    if (isButtonActionExecAsyncService(action.action)) {
      result.push(
        ...getExecAsyncServiceActionReference({
          action: action.action,
          index: action.index,
          widget,
          path,
        }),
      );
    }
  });

  return result;
}

function getExecAsyncServiceActionReference(params: {
  action: IButtonActionExecAsyncService;
  index: number;
  widget: IButtonWidget;
  path: IReferencePath;
}): IReference[] {
  const { action, index, widget, path } = params;
  return (
    action.outputs?.map(output => ({
      type: ReferenceType.Widget,
      widgetType: null,
      id: `${widget.id}-${output.name}`,
      code: `${output.name}`,
      path: [
        ...path,
        {
          direction: ReferencePathDirection.Child,
          code: getActionDataObjectName(widget, index),
        },
      ],
      field: output.type,
      label: `${widget.code}: ${output.name}`,
    })) ?? []
  );
}
